<template>
    <div class="mobile__modal" :class="{'active': show}">
        <div class="bg_color" @click="this.$emit('update:show', false)"></div>
        <div class="content">
            <nav class="mobile-menu">
                <ul>
                        <li v-for="(item, index) in pages" :key="index" class="menu-item">
                                <router-link :to="item.url">{{ item.title }}</router-link>
                                <!-- <button 
                                v-if="item.submenu" 
                                 
                                class="toggle-submenu" :class="{active : isOpen(index)}"
                                >
                                <svg width="15.007812" height="9.004150" viewBox="0 0 15.0078 9.00415" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <defs/>
                                    <path id="Vector 1" d="M1 8L7.5 1L14 8" stroke="#041620" stroke-opacity="0.720000" stroke-width="2.000000" stroke-linejoin="round" stroke-linecap="round"/>
                                </svg>

                                </button> -->
                            <!-- <ul v-if="item.submenu" class="submenu" v-show="isOpen(index)">
                                <li v-for="(subItem, subIndex) in item.submenu" :key="subIndex">
                                    <a :href="subItem.link">{{ subItem.label }}</a>
                                </li>
                            </ul> -->
                        </li>
                    </ul>
            </nav>
            <!-- <ButtonOrange style="width: 100%; margin-top: 24px;" class="white">Sell</ButtonOrange> -->
             <div @click="this.$emit('update:show', false); this.$scrollTo('sell');">Sell</div>
        </div>

    </div>
</template>

<script>
import ButtonOrange from '../UI/ButtonOrange.vue';
export default {
    props: {
        pages: [Array,Object],
        show: Boolean,
    },
    components: {
        ButtonOrange,
    },
    data() {
        return {
        }
    },
    methods: {
        // toggleSubmenu(index) {
        //     const isOpen = this.openIndexes.includes(index);
        //     if (isOpen) {
        //         this.openIndexes = this.openIndexes.filter(i => i !== index);
        //     } else {
        //         this.openIndexes.push(index);
        //     }
        // },
        // isOpen(index) {
        //     return this.openIndexes.includes(index);
        // },
    },
}
</script>

<style scoped>
.content > div{
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 32px;
    background: rgb(255, 183, 16);
    width: 100%;
    height: 44px;
    margin-top: 24px;

    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
    position: relative;
    overflow: hidden;
    border: 2px solid transparent;
    transition: all 0.3s ease-in-out;
}
.mobile-menu ul {
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 0;
    backdrop-filter: blur(51px);
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08),0px 0px 4px 0px rgba(0, 0, 0, 0.04),0px 3px 32px 0px rgba(109, 109, 109, 0.14);
    background: white;
    border-radius: 15px;
}
.mobile-menu ul li{

}
.mobile-menu .submenu li{
    padding: 18px 16px;
    padding-left: 26px;
    border-top: 1px solid rgba(4, 22, 32, 0.12);
    background: white;
}
.mobile-menu .menu-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 56px;
  height: max-content;
  border-bottom: 1px solid rgba(4, 22, 32, 0.12);
}
.mobile-menu .menu-item:last-of-type{
    border-bottom: unset;
}
.mobile-menu .menu-item a{
    color: rgb(4, 22, 32);
    font-size: 16px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0.6%;
    text-align: left;
    position: relative;
    z-index: 2;
    width: 100%;
    height: 56px;
    padding: 0 16px;
    display: flex;
    align-items: center;
}
.mobile-menu .toggle-submenu {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
}
.mobile-menu .toggle-submenu svg {
    rotate: 180deg;
    transition: all 0.5s ease;
}
.mobile-menu .toggle-submenu.active svg {
    rotate: 0deg;
}


.bg_color {
    opacity: .5;
    background: #292929;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    transition: opacity 1s cubic-bezier(.16,1,.3,1);
}
.mobile__modal.active{  
    visibility: hidden;
    opacity: 0;
}
.content{
    top: 16px;
    position: absolute;
    right: 10px;
    height: max-content;
    width: 385px;

}
@media (max-width: 768px) { 
    .content{
        width: calc(100% - 20px);
    }
}
</style>